<ng-container *ngIf="image && primaryLabel && href">
  <a
    floAnalytics
    [name]='"Avatar Card"'
    [analyticsProperties]="analyticsProperties"
    [floCustomLink]='href'
    data-test="avatar-card"
    class="avatar-card-container">
    <!-- layout === standard -->
    <!-- Standard model view, a row on larger screens and a column on 'md' and smaller-->
    <div
      class="avatar-card-container__card align-items-center d-flex flex-lg-row flex-column"
      *ngIf="layout === 'standard'"
      >
      <div class="m-lg-0 position-relative me-lg-2 pe-lg-1 mb-lg-0 m-auto pe-0 mb-2">
        <ng-container *ngTemplateOutlet="secondaryIconTmpl"></ng-container>
        <ng-container *ngTemplateOutlet="primaryImageTmpl"></ng-container>
      </div>
      <div class="d-flex flex-column justify-content-center align-items-lg-start">
        <div class="avatar-card-container__primary-label h6 mb-0 font-normal text-lg-start text-line-clamp-2 apply-text-hover text-center">{{ primaryLabel }}</div>
        <div
          *ngIf="secondaryLabel"
          class="avatar-card-container__secondary-label h6 mb-0 font-normal text-lg-start text-line-clamp-2 text-center"
          data-test="avatar-card-secondary-label">{{ secondaryLabel }}</div>
      </div>
    </div>
    <!-- layout === horizontal -->
    <!-- A non-responsive layout that always displays as a row -->
    <div
      class="avatar-card-container__card align-items-center d-flex"
      *ngIf="layout === 'horizontal'"
      >
      <div class="position-relative me-2 pe-1">
        <ng-container *ngTemplateOutlet="secondaryIconTmpl"></ng-container>
        <ng-container *ngTemplateOutlet="primaryImageTmpl"></ng-container>
      </div>
      <div class="d-flex flex-column justify-content-center align-items-start">
        <div class="avatar-card-container__primary-label h6 mb-0 font-normal text-start text-line-clamp-2 apply-text-hover">{{ primaryLabel }}</div>
        <div
          *ngIf="secondaryLabel"
          class="avatar-card-container__secondary-label h6 mb-0 font-normal text-start text-line-clamp-2"
          data-test="avatar-card-secondary-label">{{ secondaryLabel }}</div>
      </div>
    </div>
  </a>
  <ng-template #primaryImageTmpl>
    <img
      [src]="image | floImage: 200 | async"
      class="avatar-card-container__image no-skeleton rounded-circle"
      loading="lazy"
      alt="{{ primaryLabel }}"
      data-test="avatar-card-image">
  </ng-template>
  <ng-template #secondaryIconTmpl>
    <div *ngIf="secondaryIcon" class="secondary-icon-container position-absolute rounded-circle">
      <flo-svg-icon
        [altText]="secondaryIcon"
        [icon]="secondaryIcon"
        width="1.1em"></flo-svg-icon>
    </div>
  </ng-template>
</ng-container>
